import React from "react"

const TILE = 256
const ZOOM = 16
// Half of the widest/tallest area the strip can show; tiles outside it are never requested.
const HALF_W = 340
const HALF_H = 80

// Web Mercator: lat/lng to world pixel coordinates at ZOOM.
const project = (lat: number, lng: number) => {
  const scale = TILE * Math.pow(2, ZOOM)
  const sin = Math.sin((lat * Math.PI) / 180)
  return {
    x: ((lng + 180) / 360) * scale,
    y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * scale,
  }
}

interface PlaceMiniMapProps {
  lat: number
  lng: number
  color?: string | null
}

// Static, non-interactive map built from a handful of lazy-loaded OSM tiles: no map instance per card.
const PlaceMiniMap = ({ lat, lng, color }: PlaceMiniMapProps) => {
  const center = project(lat, lng)
  const tiles: { x: number; y: number }[] = []
  for (let x = Math.floor((center.x - HALF_W) / TILE); x <= Math.floor((center.x + HALF_W) / TILE); x++)
    for (let y = Math.floor((center.y - HALF_H) / TILE); y <= Math.floor((center.y + HALF_H) / TILE); y++)
      tiles.push({ x, y })

  return (
    <a
      className="feed-minimap"
      href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`}
      target="_blank"
      rel="noreferrer"
    >
      <div className="feed-minimap-tiles">
        {tiles.map(tile => (
          <img
            key={`${tile.x}-${tile.y}`}
            src={`https://tile.openstreetmap.org/${ZOOM}/${tile.x}/${tile.y}.png`}
            alt=""
            loading="lazy"
            decoding="async"
            draggable={false}
            style={{ left: tile.x * TILE - center.x, top: tile.y * TILE - center.y }}
          />
        ))}
      </div>
      <i className="fas fa-map-marker-alt feed-minimap-pin" style={{ color: color || "#dc2626" }} />
      <span className="feed-minimap-credit">© OpenStreetMap</span>
    </a>
  )
}

export default PlaceMiniMap
